import axios from "axios";

export default {
    create(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "public/professional",
        });
    },
    delete(data, id) {
        return axios({
            method: "delete",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/professional/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updatePublic(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "public/professional",
        });
    },
    getAllVisitTypes(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/visitTypes",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllRoles(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/roles",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    invite(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/professional",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/professional/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllActive() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/professionals/active",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAll() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/professionals",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    update(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/professional",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllSessions() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/professional/sessions",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    saveWorkscheduleGlobal(id, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                id +
                "/workschedule/global",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getWorkscheduleGlobal(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                id +
                "/workschedule/global",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    assignRole(idProfessional, idRole) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/role/" +
                idRole +
                "/assign",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    desassignRole(idProfessional, idRole) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/role/" +
                idRole +
                "/desassign",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllHistoricsStoreShare(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                id +
                "/historics/store/share",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllHistoricsStorePerformance(id, currentPage = 0, pageSize = 10, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                id +
                "/historics/store/performance?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllHistoricsStore(id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                id +
                "/historics/store",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findHistoricsStore(idProfessional, idPatient, idHistoricStore) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional + "/patient/" + idPatient +
                "/historic/store/" +
                idHistoricStore,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findQuestionary(idProfessional, id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/questionary/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    findHistoric(idProfessional, id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/historic/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    saveHistoricsStore(data, id) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                id +
                "/historic/store/" +
                data.id +
                "/completing",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createHistoricsStore(data, id) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                id +
                "/historic/store",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllTemplates(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/historics/templates",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllTemplatesRating(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/questionarys/templates",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllTemplatesSurvey(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/questionarys/survey/templates",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllTemplatesSurveyPerformance(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/questionarys/survey/templates/performance",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    addHistoricToHistoricStore(idProfessional, idHistoricStore, data) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/historic/store/" +
                idHistoricStore +
                "/add",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEvents(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/schedule/events",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllEventsVuetify(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/schedule/events/vuetify",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    changeSecuredHistoricStore(idProfessional, historicStoreId, secured, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/historic/store/" +
                historicStoreId +
                "/secured/" +
                secured,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    requestActivateRecipe(idProfessional) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/requestActivateRecipe",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    activateRecipe(idProfessional, activate) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/activateRecipe/" +
                activate,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getEvent(id, idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/schedule/event/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteEvent(id, idProfessional) {
        return axios({
            method: "delete",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/schedule/event/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getWorkscheduleIpros(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/workschedule/ipros",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createSeason(idProfessional, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/season",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createHourSeason(idProfessional, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/season/hour",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateSeason(idProfessional, data) {
        return axios({
            method: "put",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/season",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getSeason(idProfessional, id) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/season/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteHourSeason(idProfessional, id) {
        return axios({
            method: "delete",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/season/hour/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteSeason(idProfessional, id) {
        return axios({
            method: "delete",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/season/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllSeason(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/seasons",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllSchedulesWorkschedule(idProfessional) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/workschedule/days",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createHourScheduleInDayScheduleWorkschedule(idProfessional, data) {
        return axios({
            method: "post",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/workschedule/day/hour",
            data: data,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteHourScheduleInDayScheduleWorkschedule(
        idProfessional,
        idWorkschedule,
        idDay,
        id
    ) {
        return axios({
            method: "delete",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/workschedule/" +
                idWorkschedule +
                "/day/" +
                idDay +
                "/hour/" +
                id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllSchedulesWorkscheduleIpros(idProfessional, idWorkschedule) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/workschedule/ipros/" +
                idWorkschedule +
                "/days",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateDurationWorkscheduleIpros(idProfessional, idWorkschedule, duration) {
        return axios({
            method: "put",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                idProfessional +
                "/workschedule/ipros/" +
                idWorkschedule +
                "/duration/" +
                duration,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    generateWordStoreHistoric(professionalId, historicStoreId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                professionalId +
                "/historic/store/" +
                historicStoreId +
                "/report/word",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    generatePdfStoreHistoric(professionalId, historicStoreId, data) {
        return axios({
            method: "post",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/" +
                professionalId +
                "/historic/store/" +
                historicStoreId +
                "/report",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    changeOrganization(organizationId) {
        return axios({
            method: "post",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/professional/organization/" +
                organizationId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
